import env from "src/env"
import makeAuthRequest from "./makeAuthRequest"

const {
  REACT_APP_API_URL,
  REACT_APP_ACCOUNTS_ORIGIN,
  REACT_APP_API_ORIGIN,
} = env

const defaultIsAuthError = (status, body) =>
  status === 401 &&
  [
    `authentication.token.expired`,
    `authentication.token.invalid`,
    `authentication.required`,
  ].some(one => one === body.errorCode)

const defaultInsertToken = (token, params) => ({
  ...params,
  headers: {
    ...params.headers,
    Authorization: `Bearer ${token}`,
  },
})

// Реквест со стандартными параметрами авторизации, используемыми на планнере
export const plannerAuthRequest = makeAuthRequest({
  baseURL: REACT_APP_API_URL,
  isAuthError: defaultIsAuthError,
  insertToken: defaultInsertToken,
})

// Реквест для accounts
export const accountsAuthRequest = makeAuthRequest({
  baseURL: REACT_APP_ACCOUNTS_ORIGIN,
  isAuthError: defaultIsAuthError,
  insertToken: defaultInsertToken,
})

// Реквест для toir-service
export const commonApiAuthRequest = makeAuthRequest({
  baseURL: REACT_APP_API_ORIGIN,
  isAuthError: defaultIsAuthError,
  insertToken: defaultInsertToken,
})
